import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../../components/isLoading";
import BlogsTableContainer from "../TableContainer";
import formatBlogs from "../../../helpers/formatBlog";
import { fetchBlogsData } from "../../../redux/blogs/index";
import { Button } from "@mui/material";
import { NavLink } from "react-router-dom";

export default () => {
	const blogsData = useSelector((state) => state.blogsGlobalStore);

	const dispatch = useDispatch();

	const [dataState, setDataState] = useState({
		formattedBlogsData: [],
		authorRecords: [],
		currentPage: 0,
	});

	useEffect(() => {
		dispatch(fetchBlogsData(dataState.currentPage));
	}, [dataState.currentPage]);

	let formattedBlogsData = [];

	useEffect(() => {
		for (const blog of blogsData.data?.data || []) {
			formattedBlogsData.push(formatBlogs(blog, "blogs-stories"));
		}

		setDataState((prevState) => ({
			...prevState,
			formattedBlogsData,
			currentPage: blogsData.data.pagination?.offset || 0,
		}));
	}, [blogsData.data]);

	const onPageChange = (pageNumber) =>
		setDataState((prevState) => ({ ...prevState, currentPage: pageNumber }));

	return (
		<div>
			{blogsData.loading && !blogsData.data[0] ? (
				<Loading />
			) : (
				<>
					<div
						style={{
							padding: "15px",
							float: "right",
						}}
					>
						<Button
							variant="outlined"
							component={NavLink}
							to="/blogs-stories/new"
							sx={{
								color: "#E00186",
								border: "1px solid #E00186",
								fontFamily: "Arial",
								"&:hover": {
									color: "#fff",
									backgroundColor: "#E00186",
									border: "1px solid #E00186",
								},
							}}
						>
							Add new Blog
						</Button>
					</div>
					<BlogsTableContainer
						isUpdating={blogsData.loading && blogsData.data[0]}
						formattedData={dataState.formattedBlogsData}
						hidden={[""]}
						title="All Blogs"
						pagination={blogsData.data.pagination || {}}
						onPageChange={onPageChange}
					/>
				</>
			)}
		</div>
	);
};
